import styled from "@emotion/styled";
import { IonContent } from "@ionic/react";
import React from "react";
import MealInsights from "src/ui/components/MealInsights/MealInsights";

const StyledIonContent = styled(IonContent)`
  background-color: var(--color-cream);
`;

const PageWrap = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: calc(
    var(--safe-area-inset-bottom, 0px) + var(--navbar-padding-bottom, 55px)
  );
`;

const MealsPage = () => {
  return (
    <StyledIonContent scrollY>
      <PageWrap>
        <MealInsights />
      </PageWrap>
    </StyledIonContent>
  );
};

export default MealsPage;
